import { useMutation } from '@tanstack/react-query';
import assignTCAPUser from '@/API/TCAPUser/assignTCAPUser';

import { toast } from 'react-toastify';

const useAssignTCAPUser = ({
    tcapUserId,
    platformUserId,
    accountScope,
    refetchPlatformUsers,
    setIsAssigning,
}) => {
    return useMutation({
        mutationFn: async () => {
            try {
                await assignTCAPUser({
                    tcapUserId,
                    platformUserId,
                    scope: accountScope,
                });
                await refetchPlatformUsers();
                setIsAssigning(false);
                toast.success('Linked Platform User!');
            } catch (error) {
                toast.error(error?.message || 'Failed to link platform users');
                throw new Error(
                    error?.message || 'Failed to link platform users',
                );
            }
        },
    });
};

export default useAssignTCAPUser;
